import React, {useEffect, useState} from 'react'

const Preloader = () => {
const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setIsLoading(false);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);

      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

   if (isLoading) {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gradient-to-br from-white to-gray-50 z-[9999] animate-fade-in">
      <div className="relative flex items-center justify-center animate-slide-up w-[120px] h-[120px] min-[360px]:w-[140px] min-[360px]:h-[140px] min-[480px]:w-[160px] min-[480px]:h-[160px] md:w-[200px] md:h-[200px]">
        {/* Animated circle background */}
        <div className="absolute rounded-full bg-gradient-to-br from-blue-800 via-blue-500 to-blue-400 opacity-10 animate-rotate-bg w-[100px] h-[100px] min-[360px]:w-[120px] min-[360px]:h-[120px] min-[480px]:w-[140px] min-[480px]:h-[140px] md:w-[180px] md:h-[180px]"></div>
        
        {/* Animated spinner */}
        {/* <div className="absolute w-[80px] h-[80px] min-[360px]:w-[100px] min-[360px]:h-[100px] min-[480px]:w-[120px] min-[480px]:h-[120px] md:w-[140px] md:h-[140px]">
          <div className="absolute w-full h-full border-[1.8px] min-[360px]:border-2 min-[480px]:border-[2.5px] md:border-[3px] border-transparent rounded-full border-t-blue-800 border-r-blue-500 animate-spin-slow"></div>
          <div className="absolute border-transparent rounded-full border-t-blue-500 border-r-blue-400 animate-spin-reverse
            border-[1.8px] min-[360px]:border-2 min-[480px]:border-[2.5px] md:border-[3px]
            top-[6px] left-[6px] w-[68px] h-[68px]
            min-[360px]:top-[7px] min-[360px]:left-[7px] min-[360px]:w-[86px] min-[360px]:h-[86px]
            min-[480px]:top-[8px] min-[480px]:left-[8px] min-[480px]:w-[104px] min-[480px]:h-[104px]
            md:top-[10px] md:left-[10px] md:w-[120px] md:h-[120px]
          "></div>
          <div className="absolute border-transparent rounded-full border-t-blue-400 border-r-blue-300 animate-spin-linear
            border-[1.8px] min-[360px]:border-2 min-[480px]:border-[2.5px] md:border-[3px]
            top-[12px] left-[12px] w-[56px] h-[56px]
            min-[360px]:top-[14px] min-[360px]:left-[14px] min-[360px]:w-[72px] min-[360px]:h-[72px]
            min-[480px]:top-[16px] min-[480px]:left-[16px] min-[480px]:w-[88px] min-[480px]:h-[88px]
            md:top-[20px] md:left-[20px] md:w-[100px] md:h-[100px]
          "></div>
        </div> */}

        {/* Logo/Brand text */}
        <div className="relative z-10 text-center animate-pulse-slow">
          <h2 className="m-0 font-bold text-blue-800 tracking-[0.5px] font-sans text-[18px] min-[360px]:text-[20px] min-[480px]:text-[24px] md:text-[28px]">Querencia</h2>
          <p className="m-[4px_0_0_0] font-medium text-blue-500 tracking-[1px] uppercase font-sans text-[9px] min-[360px]:text-[10px] min-[480px]:text-[11px] md:text-[12px]">Micro Credit</p>
          <div className="flex justify-center gap-[4px] mt-[14px] min-[360px]:gap-[5px] min-[360px]:mt-[16px] min-[480px]:gap-[5px] min-[480px]:mt-[20px] md:gap-[6px] md:mt-[20px]">
            <span className="rounded-full bg-gradient-to-br from-blue-800 to-blue-500 animate-bounce-custom w-[5px] h-[5px] min-[360px]:w-[6px] min-[360px]:h-[6px] min-[480px]:w-[7px] min-[480px]:h-[7px] md:w-[8px] md:h-[8px]"></span>
            <span className="rounded-full bg-gradient-to-br from-blue-800 to-blue-500 animate-bounce-custom [animation-delay:0.2s] w-[5px] h-[5px] min-[360px]:w-[6px] min-[360px]:h-[6px] min-[480px]:w-[7px] min-[480px]:h-[7px] md:w-[8px] md:h-[8px]"></span>
            <span className="rounded-full bg-gradient-to-br from-blue-800 to-blue-500 animate-bounce-custom [animation-delay:0.4s] w-[5px] h-[5px] min-[360px]:w-[6px] min-[360px]:h-[6px] min-[480px]:w-[7px] min-[480px]:h-[7px] md:w-[8px] md:h-[8px]"></span>
          </div>
        </div>
      </div>
    </div>
  );
   } else {
    return null;
  }
}

export default Preloader